module.exports = __webpack_public_path__ + "48c3c9432fc0f90a2f11b40eb241c405.pdf";